import { PORTAL_UI_V2 } from "../config/uiTheme";
import DashboardLegacy from "./dashboard/DashboardLegacy";
import DashboardV2 from "./dashboard/DashboardV2";

const Dashboard = () => (PORTAL_UI_V2 ? <DashboardV2 /> : <DashboardLegacy />);

export default Dashboard;
